<template>
    <div class="row">
        <div class="col-12 py-3">
            <div class="flex">
                <a href="#" @click.prevent="loadSuggestions" class="btn btn-sm btn-success">
                    Find Similar Courses
                </a>
                <a
                    v-if="showSuggestions"
                    href="#"
                    class="btn btn-sm btn-secondary ml-2"
                    @click.prevent="clear"
                >
                    Clear
                </a>
            </div>
            <div v-if="showSuggestions" class="pt-2">
                <div v-if="suggestions.length">
                    <p
                        v-for="suggestion in suggestions"
                        v-html="suggestion"
                        class="mb-0"
                    ></p>
                </div>
                <p v-else>
                    No similar courses were found.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        course: {
            required: true,
            type: Object,
        }
    },
    data() {
        return {
            showSuggestions: false,
            suggestions: [],
        }
    },
    methods: {
        loadSuggestions() {
            this.axios
                .get(this.route("admin.courses.search"), {
                    params: { keywords: this.course.name, course_id: this.course.id }
                })
                .then(response => {
                    this.suggestions = response.data.results
                        .filter(course => course.value != this.course.id)
                        .map(course => {
                            return course.label.replaceAll(
                                this.course.name,
                                `<strong class="text-primary">${this.course.name}</strong>`
                            );
                        });

                    this.showSuggestions = true;
                })
        },

        clear() {
            this.showSuggestions = false;
            this.suggestions = [];
        }
    }
}
</script>